import { useCallback } from 'react';

export const useAlert = () => {
  const showAlert = useCallback((_copy: string) => {
    // Ignore on Web
  }, []);

  return { showAlert };
};
